import { render, staticRenderFns } from "./submit-order.vue?vue&type=template&id=5b1fafbf&scoped=true"
import script from "./submit-order.vue?vue&type=script&lang=js"
export * from "./submit-order.vue?vue&type=script&lang=js"
import style0 from "./submit-order.vue?vue&type=style&index=0&id=5b1fafbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1fafbf",
  null
  
)

export default component.exports